/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardUsageDto } from '../../models/dashboard-usage-dto';

export interface AnalyticsTopDashboardsGet$Json$Params {
  take?: number;
}

export function analyticsTopDashboardsGet$Json(http: HttpClient, rootUrl: string, params?: AnalyticsTopDashboardsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardUsageDto>>> {
  const rb = new RequestBuilder(rootUrl, analyticsTopDashboardsGet$Json.PATH, 'get');
  if (params) {
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DashboardUsageDto>>;
    })
  );
}

analyticsTopDashboardsGet$Json.PATH = '/analytics/top-dashboards';
